jQuery(document).ready(function($){
	// Prevent scrolling when mobile menu is open
	$('.navbar-toggler').click( function () {
		$('body').toggleClass('prevent-scroll');
	})
	if ( $(window).width() <= 1200 ) {

  	//open menu on click, expand dropdown menu
  	$('#menuToggle').click(function(e){
			$('.navbar-wrapper').toggleClass('active');
			if( $('.navbar-wrapper').hasClass('active') ){
				$('.homepage-anchor').hide();
			} else {
				$('.homepage-anchor').show();
			}
		});

  	$('.nav-link').click(function(){
			$("#navbarNavDropdown").removeClass("show");
		  $("button.navbar-toggler").addClass("collapsed");
		  $("button.navbar-toggler").attr("aria-expanded","false");
		});

  } else {

		//add dropdown menu toggle functionality to down arrow
		$('.dropdown-toggle.nav-link').append('<a href="#" class="ms-3" data-toggle="dropdown" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-solid fa-chevron-down"></i></a>');
  	
  	$('.dropdown-toggle.nav-link a').click(function(e){
  		$( this ).toggleClass('active');
  		$( this ).parent().siblings('.dropdown-menu').toggleClass('show');
  	})
  }

  // play/pause functionality for full width videos
	$('.block-video-full.new-vid').click (function (e) {
		e.preventDefault();
		var videoBlock = $(this);

		if (videoBlock.hasClass('video-file')) {
			var video = videoBlock;
		} else {
			var video = videoBlock.find('video');
		}
		
		video.trigger('play');
		videoBlock.removeClass('new-vid');
		video.attr('controls', true);
	});

	
});

document.addEventListener("DOMContentLoaded", function(event) {

  window.addEventListener("load", function(e) {

	  gsap.registerPlugin(DrawSVGPlugin);
	  gsap.registerPlugin(ScrollTrigger);

	  var heroHeight = jQuery('.homepage-intro-video').height();

	  let fade = gsap.utils.toArray('.fade');

	  fade.forEach((text, i) => {
	  	gsap.to(text, {
				opacity: 1,
				y: 0,
				ease: "back.out(1.7)",
				scrollTrigger: {
					trigger: text
				}
			});
	  });

		var desktopWidth = window.matchMedia("(min-width: 992px)");
		var tabletWidth = window.matchMedia("(min-width: 768px)");

	  if (desktopWidth.matches) {
	  	var startPoint = 'top center';
	    var heroOffset = 200;
  	} else if (tabletWidth.matches) {
    	var startPoint = 'top center';
    	var heroOffset = 400;
	  } else {
	    var startPoint = 'top 55%';
	  	var heroOffset = 300;
	  }

	  gsap.to('.scroll-header', {
	  	scrollTrigger: {
	  		trigger: '.scroll-header',
	  		start: startPoint,
	  		end: '+=' + (heroHeight - heroOffset),
	  		scrub: true,
	  		pin: true,
	  		// markers: true
	  	}
	  })

		var chartTl = gsap.timeline({
		  scrollTrigger: {
		  	trigger: '.chart',
		    start: 'top +=600',
		    end: '+=500',
		    // markers: true
		  }
		});

		gsap.set('.chart-line', {visibility: 'visible'});

		chartTl.from('.chart-line', .3, {
		  stagger: .5,
		  drawSVG: "100% 100%",
		  delay: 0,
		  ease: "power4.out"
		}, 0.03);

		chartTl.fromTo('.chart-label', { opacity: 0 }, { opacity: 1, duration: 1, stagger: 0.5 }, "<");
		chartTl.fromTo('.chart-fill', { opacity: 0 }, { opacity: 1, duration: 1, stagger: 1 }, "<");

	});
	
});